import { ReactNode } from "react";

interface PlaceholderPageProps {
  title: string;
  description: string;
  icon: ReactNode;
}

export default function PlaceholderPage({ title, description, icon }: PlaceholderPageProps) {
  return (
    <div className="flex flex-col items-center justify-center min-h-[calc(100vh-80px)] p-8">
      <div className="max-w-lg text-center">
        <div className="mb-6 mx-auto w-24 h-24 flex items-center justify-center rounded-full bg-gradient-to-br from-cyan-100 to-blue-50 dark:from-cyan-900/30 dark:to-blue-900/20">
          <div className="text-gradient-blue">
            {icon}
          </div>
        </div>
        <h1 className="text-4xl font-bold mb-4 text-gradient-blue">{title}</h1>
        <p className="text-lg text-gray-600 dark:text-gray-400 mb-8">
          {description}
        </p>
        <div className="w-full h-2 bg-gradient-to-r from-cyan-500 via-blue-500 to-indigo-500 rounded-full mb-8"></div>
        <p className="text-sm text-gray-500 dark:text-gray-500">
          This feature is under development and will be available soon.
        </p>
      </div>
    </div>
  );
}